import { SortOrder } from '@getaccept/fried-tofu';
import type { LoadMeetingsPayload } from '../types';

export default class MeetingConstants {
  static defaultPayload: LoadMeetingsPayload = {
    limit: 10,
    offset: 0,
    sortBy: 'date',
    sortOrder: SortOrder.Asc,
  };
}
